var _a;
const isServer = () => typeof window === 'undefined';
const initialState = {
    hideNav: false,
    isSidebarOpen: false,
    isLogged: typeof __MOCK__ === 'undefined' ? !isServer() && ((_a = window.__user__) === null || _a === void 0 ? void 0 : _a.isLogged) === 'true' : true,
    disclaimers: []
};
export default initialState;
